import { useState, useEffect, React } from "react";
import $ from 'jquery';
// core components
import './About.css';
import Footer from "../Footer/Footer.js";
import Loader from "../../components/loader/loader.js";
import About from "../../assets/images/about.png"
import Support from "../../assets/images/support.png"
import Education from "../../assets/images/Education.png"
import Empower from "../../assets/images/empower.png"
import Adopt from "../../assets/images/adopt.png"
import Health from "../../assets/images/Health.png"
import Introduction from "../../assets/videos/introduction.mp4"
import Public from "../../assets/images/Public.png"
import {Link} from "react-router-dom";

export default function Home() {
   const [loading, setLoading] = useState(true);
 
   useEffect(() => {
     const timer = setTimeout(() => {
       setLoading(false);
     }, 2500); 
 
     return () => clearTimeout(timer);
   }, []);
   $(window).scroll(function () {
    if ($(this).scrollTop()) {
      $('header').addClass('fixedTop');
    } else {
      $('header').removeClass('fixedTop');
    }
  });
  useEffect(() => {
     window.scrollTo(0, 0)
   }, [])
  return (
<div>
{loading ? <Loader /> :
    <div>
        <div className="vision_header">
          <section className="vision_banner">
            <div className="container-fluid custom-container">
               <div className="row">
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_text">
                        <h1>ABOUT US</h1>
                       </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-12">
                     <div className="vision_banner_img">
                     <img src={About} alt="about" className="img-fluid"/>
                     </div>
                  </div>
               </div>
               </div>
            
                  
            </section>
            <section className="about_content">
               <div className="container-fluid custom-container">
                  <div className="about_content_text">
                   <div className="about_text">
                           <h2>About Us</h2>
                           <p>Jayam Charitable Trust is a dedicated organization committed to empowering visually impaired individuals, elderly people, and underserved communities through education, health support, and social initiatives. Our efforts are driven by a passionate team working together to make a meaningful impact.</p>
                        </div>
                  </div>
               </div>
               </section>
               <div className="container-fluid custom-container">
                  
               <div class="aboutvideo">
                  <h2>Introduction</h2>
                               <div class="item iframe-container"><iframe src={Introduction} frameborder='0'  allowfullscreen title='Jayam Charitable Trust'muted/></div>
                             </div>
                             </div>
            <section className="what_we_do">
               <div className="container-fluid custom-container">
                  <div className="what_we_do_text">
                     <h2>What We Do</h2>
                     <div className="row">
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                           <div className="whatwedo_text">
                              <img src={Empower} alt="empower" className="img-fluid"/>
                              <h2>Empowering the Visually Impaired</h2>
                              <ul>
                                 <li>Accessible learning resources</li>
                                 <li>Life skills coaching</li>
                                 <li>Official communication & job readiness training</li>
                                 <li>Modern assistive technologies</li>
                                 <li>Personal counselling and motivation</li>
                                 <li>Scribe services and regular moral visits</li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                          <div className="whatwedo_text">
                              <img src={Support} alt="support" className="img-fluid"/>
                              <h2>Supporting the Elderly</h2>
                              <ul>
                                 <li>Free Ayurvedic and wellness check-ups</li>
                                 <li>Lifestyle awareness and health monitoring</li>
                                 <li>Companionship and emotional support</li>
                                 <li>Medical sponsorships and medicine kits</li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                          <div className="whatwedo_text">
                              <img src={Education} alt="Education" className="img-fluid"/>
                              <h2>Educational & Charitable Support</h2>
                              <ul>
                                 <li>School admissions and exam support</li>
                                 <li>Learning supplies and writing assistance</li>
                                 <li>Provision of dress and daily essentials</li>
                                 <li>Representation to the government for fair and rightful needs</li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-md-5">
                           <div className="whatwedo_text">
                              <img src={Health} alt="Health" className="img-fluid"/>
                              <h2>Health & Wellness Drives</h2>
                              <ul>
                                 <li>Blood donation camps</li>
                                 <li>Preventive and general medical camps</li>
                                 <li>Wellness awareness sessions</li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-md-5">
                          <div className="whatwedo_text">
                              <img src={Public} alt="Public" className="img-fluid"/>
                              <h2>Public Awareness & Social Impact</h2>
                              <ul>
                                 <li>Short films and creative visuals</li>
                                 <li>Career counselling and youth development</li>
                                 <li>Empowerment sessions for women and students</li>
                              </ul>
                           </div>
                        </div>
                        <div className="col-lg-4 col-md-6 col-sm-12 col-12 mt-md-5">
                          <div className="whatwedo_text">
                              <img src={Adopt} alt="adopt" className="img-fluid"/>
                              <h2>Fundraising & Adoption Programs</h2>
                              <ul>
                                 <li>Sponsor-a-life initiatives</li>
                                 <li>Community adoption programs</li>
                                 <li>Events organized for raising awareness and funding</li>
                              </ul>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               </section>
                  
           <Footer />
        </div>
     
    </div>
    }
    </div>
  )
}
